import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchAll as fetchAllSprint } from '../sprint/actions';
import { fetchAll as fetchAllBypassed } from '../bypassed/actions';
import { fetchAll as fetchAllQuick } from '../quick/actions';
import { getAllSprintSubscriptions, getAllBypassedSubscriptions, getAllQuickSubscriptions, getUser } from 'reducers';
import SubscriptionList from './SubscriptionList';

const filterByStatuses = (subs, statuses, statusKey) => {
  return subs.filter(sub => statuses.includes(sub[statusKey]))
}

class SubscriptionListComponent extends Component {

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    if (this.props.userId !== oldProps.userId) {
      this.fetchData();
    }
  }

  fetchData() {
    const { fetchAllSprint, fetchAllBypassed, fetchAllQuick, userId } = this.props;
    fetchAllSprint(userId);
    fetchAllBypassed(userId);
    fetchAllQuick(userId);
  }

  render() {
    return <SubscriptionList {...this.props} />
  }
}

const mapStateToProps = (state, { subStatuses }) => {
  let sprintSubs = getAllSprintSubscriptions(state);
  let bypassedSubs = getAllBypassedSubscriptions(state);
  let quickSubs = getAllQuickSubscriptions(state);
  if (subStatuses) {
    sprintSubs = filterByStatuses(sprintSubs, subStatuses, 'sprint_status');
    bypassedSubs = filterByStatuses(bypassedSubs, subStatuses, 'bypassed_status');
    quickSubs = filterByStatuses(quickSubs, subStatuses, 'quick_status');
  }

  return {
    userId: getUser(state) && getUser(state).id,
    sprintSubs,
    bypassedSubs,
    quickSubs,
  }
};

const mapDispatchToProps = {
  fetchAllSprint,
  fetchAllBypassed,
  fetchAllQuick,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionListComponent);
